<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-09-30 15:25:16
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-04 16:46:26
-->
<template>
  <div>
    <div class="type">
      <!-- <div class="log-box">
        <div
         v-if="codeData.indexOf('13') != -1"
          @click="changeType(1)"
          :style="{
            color: type == 1 ? '#1890FF' : '',
            borderBottom: type == 1 ? 'solid 1px #dcdfe6' : '',
          }"
          class="log"
        >
          稿件库
        </div>
        <div
         v-if="codeData.indexOf('14') != -1"
          @click="changeType(2)"
          :style="{
            color: type == 2 ? '#1890FF' : '',
            borderBottom: type == 2 ? 'solid 1px #dcdfe6' : '',
          }"
          class="log"
        >
          我的稿件
        </div>
        <div
         v-if="codeData.indexOf('15') != -1"
          @click="changeType(3)"
          :style="{
            color: type == 3 ? '#1890FF' : '',
            borderBottom: type == 3 ? 'solid 1px #dcdfe6' : '',
          }"
          class="log"
        >
          待审稿件
        </div>
        <div
         v-if="codeData.indexOf('16') != -1"
          @click="changeType(4)"
          :style="{
            color: type == 4 ? '#1890FF' : '',
            borderBottom: type == 4 ? 'solid 1px #dcdfe6' : '',
          }"
          class="log"
        >
          回收站
        </div>
      </div> -->
      <el-tabs v-model="activeName" class="type-style" type="card" @tab-click="handleClick">
        <el-tab-pane v-if="codeData.indexOf('14') != -1" label="我的稿件" name="second"></el-tab-pane>
        <el-tab-pane v-if="codeData.indexOf('15') != -1" label="待审稿件" name="third">
           <div slot="label">
              待审稿件
              <div v-if="numData.manuscriptNumber>0" class="push-box"></div>
           </div>
        </el-tab-pane>
        <!-- <el-tab-pane v-if="codeData.indexOf('313') != -1" name="five">
           <div slot="label">
              推送稿件
              <div v-if="numData.pushNumber>0" class="push-box"></div>
           </div>
        </el-tab-pane> -->
        <el-tab-pane v-if="codeData.indexOf('13') != -1" label="稿件库" name="first"></el-tab-pane>
        <el-tab-pane v-if="codeData.indexOf('16') != -1" label="回收站" name="fourth"></el-tab-pane>
      </el-tabs>
      <!-- <div class="dir"></div> -->
     
      <myMan type="2" v-if="type == 2 && codeData.indexOf('14') != -1"></myMan>
      <reBin @pustChange="pustChange" type="3" v-if="type == 3 && codeData.indexOf('15') != -1"></reBin>
      <!-- <push @pustChange="pustChange"  type="5" v-if="type == 5 && codeData.indexOf('313') != -1"></push> -->
      <draft type="1" v-if="type == 1 && codeData.indexOf('13') != -1"></draft>
      <secLib  type="4" v-if="type == 4 && codeData.indexOf('16') != -1"></secLib>
    </div>
  </div>
</template>

<script>
import draft from './components/draft_reviewed.vue';
import myMan from './components/my_manuscript.vue';
import reBin from './components/recycle_bin.vue';
import secLib from './components/section_library.vue';
import push from './components/push.vue';
import {countNum} from './all_manuscripts'
export default {
  data(){
    return {
      type:2,
      codeData:[],
      activeName:'second',
      numData:{},
    }
  },
  components:{
    draft,
    myMan,
    reBin,
    secLib,
    push
  },
  mounted(){
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    let type = sessionStorage.getItem('manuscriptsType') || this.$route.query.type;
    this.getNum();
    if(type){
      if(type == 2){
         this.activeName = 'second';
      }else if(type == 3){
         this.activeName = 'third';
      }else if(type == 1){
         this.activeName = 'first';
      }else if(type == 4){
         this.activeName = 'fourth';
      }
       this.type = type;
    }else{
      if(this.codeData.indexOf('13') == -1 && this.codeData.indexOf('14') == -1 && this.codeData.indexOf('15') == -1){
           this.activeName = 'fourth';
           this.type = 4;
           return;
      }else if(this.codeData.indexOf('14') == -1 && this.codeData.indexOf('15') == -1){
           this.activeName = 'first';
           this.type = 1;
           return;
      }else if(this.codeData.indexOf('14') == -1){
           this.activeName = 'third';
           this.type = 3;
           return;
      }else{
          this.activeName = 'second';
          this.type = 2;
      }
    }
  },
    methods:{
      changeType(type) {
      this.type = type;
    },
    pustChange(){
      this.getNum()
    },
    getNum(){
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        countNum({
          siteId:sessionStorage.getItem('siteId'),
          id:userInfo.id,
          roleId:userInfo.roleId,
          organizationId:userInfo.organizationId,
        }).then((res)=>{
            if(res.code == 0){
                this.numData = res.data;
            }
        })
    },
    handleClick(){
        if(this.activeName == 'first'){
            this.type = 1;
        }
         if(this.activeName == 'second'){
            this.type = 2;
        }
         if(this.activeName == 'third'){
            this.type = 3;
        }
         if(this.activeName == 'fourth'){
            this.type = 4;
        }
        if(this.activeName == 'five'){
            this.type = 5;
        }
      }
    }
}
</script>

<style lang="less" scoped>
  .log-box {
  //border-bottom: solid 1px #dcdfe6;
  display: flex;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 24px;
  .log {
    padding: 10px 20px;
    border-top: solid 2px #dcdfe6;
    border-left: solid 2px #dcdfe6;
    cursor: pointer;
    border-bottom: solid 2px #dcdfe6;
  }
  .log:last-child {
    border-right: solid 2px #dcdfe6;
    border-top-right-radius: 10px;
  }
  .log:first-child {
    border-top-left-radius: 10px;
  }
}
.dir {
  height: 2px;
  background: #dcdfe6;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: -2px;
}
.type-style{
  padding: 24px;
  padding-bottom: 6px;
}
/deep/ .box .search{
   padding: 0px 24px 0px 24px;
}
/deep/ .el-tabs__item.is-active{
    color: #176DE6;
}
/deep/ .el-tabs__item{
  color: rgba(102, 111, 128, 1);
  font-size: 14px;
  font-family: Roboto;
}
.push-box {
            width: 8px;
            height: 8px;
            background-color: rgba(245, 108, 108, 1);
            text-align: center;
            border-radius: 50%;
            position: absolute;
            right: 10px;
            top: 10px;
          }
</style>